import React, { Component } from 'react';
import { Grid, Segment, Header, Icon } from 'semantic-ui-react';

import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
class UserGuide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React'
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "acct_user-guide-updates.md");
        this.props.addItem("corporateSelect",false);
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
        this.props.addItem("corporateSelect",true);
    }
    render() {
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="My Account" child={[{ name: "User Guide & Getting Started", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment>
                                <Header as="h3">User Guide & Getting Started</Header>
                                <p>Hello, and WELCOME to our Client Portal!  </p>
                                <p>We're here to help and have three built-in sources of help to make using the Client Portal easy. Our help options are:</p>
                                <p><ol>
                                    <li>The <Icon name="info icon" /> Icon </li>
                                    <li>Keyword Library</li>
                                    <li>FAQs</li>
                                </ol></p>
                                <hr />
                                <Header as="h4">The <Icon name="info icon" /> Icon</Header>
                                <p>Instuctions for each screen may be accessed by clicking on the help <i class="arrow right icon"></i> icon located in the upper-right corner of a screen.</p>
                                <Header as="h4">Keyword Library</Header>
                                <p>The Keyword Library provides an alphabetical listing of all the column headers and form-field labels used throughout the Client Portal.</p>  
                                <p>The Keyword Library can be accessed by clicking on the down arrow located to the left of the <i class="users icon"></i> icon located in the upper, right-hand corner of each screen, and then selecting the "Keyword Library" option.</p>
                                <Header as="h4">FAQs</Header>
                                <p>Our *FAQs" section provides a listing of answers to the most common set of questions that first-time & newer users tend to ask.</p>
                                <p>The FAQs section can be accessed by clicking on the down arrow located to the left of the <i class="users icon"></i> icon located in the upper, right-hand corner of each screen, and then selecting the "FAQs" option.  </p>
                                <Header as="h4">Need More Help?</Header>
                                <p>If you can't find what you're looking for, please call us and let us know. We're here to help. <strong>{this.props.config.AGENCY_SUPPORT_NUMBER}</strong>.</p>
                                <p>It's simple! It's easy! It's convenient!</p>
                            </Segment>
                            {/* <Segment>
                                <Header as="h4">System Requirements</Header>
                                <p>Get from offshore.</p>
                            </Segment> */}

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
export default UserGuide;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/UserGuide.js